<a class="picture sp-mr-10" *ngIf="ownerAssigneeType(task) === 'user'" (click)="goToEmployee()">
  <ui-assignee-avatar [fromAssigneeId]="task.ownerId" [uiShowTooltip]="true" uiSize="xs"></ui-assignee-avatar>
</a>
<jira-issue-icon *ngIf="!task.ownerId && task.externalSystem === 'jira'" [issueType]="task.taskType"></jira-issue-icon>
<div class="gh-siv-item-details">
  <div class="gh-siv-item-name" [id]="'task-name-' + task.id" [attr.aria-describedby]="'okr_tasks_task_name_aria_description'" (click)="goToTask()" tabindex="0">
    <span data-test-id="task-item">{{ task.name }}</span>
    <span class="a11y-description" id="okr_tasks_task_name_aria_description">{{ task.name }}, {{ getOwnerName(task.ownerId) }}</span>
  </div>
</div>

<div class="task-due-date" *ngIf="(hasManageTasksPermission$ | async) && !confirmDelete.on">
  <div class="d-flex" *ngIf="!task.externalSystem">
    <ui-date-picker
      [uiBorderless]="true"
      [ngModel]="dueDate"
      [uiBackdrop]="true"
      [uiPlaceHolder]="'set_date' | localize"
      [uiInputReadOnly]="true"
      [a11yRequired]="true"
      [hideSuffix]="true"
      [uiOpen]="false"
      (ngModelChange)="setDueDate($event)"
      uiSize="small"></ui-date-picker>
    <div class="date-text clip-text due-date" *ngIf="task.dueDate">
      <div class="remove grey" (click)="removeDueDate()"></div>
    </div>
  </div>
</div>

<div class="task-due-date" *ngIf="(hasManageTasksPermission$ | async) === false">
  <div class="div" *ngIf="!task.externalSystem">
    <date-view [date]="task.dueDate"></date-view>
  </div>
</div>

<div class="confirm-delete-cloak" *ngIf="confirmDelete.on">
  <div class="confirm-delete-btns">
    <button (click)="delete()" ui-button uiType="primary" uiShape="round" uiSize="small" uiDanger="true">
      {{ "delete" | localize }}
    </button>
    <button (click)="confirmDelete.on = false" ui-button uiType="default" uiShape="round" uiSize="small">
      {{ "cancel" | localize }}
    </button>
  </div>
</div>

<task-status
  class="fixed-width-task-status"
  *ngIf="!confirmDelete.on"
  [disabled]="(hasManageTasksPermission$ | async) === false"
  [status]="task.status"
  [archived]="task.archived"
  [externalSystem]="externalSystem"
  (statusChange)="changeStatus($event)"></task-status>

<gh-dropdown
  *ngIf="(hasManageTasksPermission$ | async) && task.id && !confirmDelete.on"
  [menuItems]="dropdownOptions"
  [tabIndex]="-1"
  dropdownMenuClass="okr-tasks-options"
  iconName="menu-horizontal"
  data-test-id="dropdown-actions-menu">
</gh-dropdown>
